import { h, createApp } from 'vue'
import singleSpaVue from 'single-spa-vue'

import App from './App.vue'
// @ts-ignore
import('../node_modules/@book24/ui-components/dist/css/Counter.css')
// @ts-ignore
import('../node_modules/@book24/ui-components/dist/css/ButtonControl.css')
// @ts-ignore
import('../node_modules/@book24/ui-components/dist/css/Loader.css')

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render (this: any & {
      productId: string,
      productType: string,
      cartRoute: string,
      checkoutRoute: string,
      basketButtonTitle: string
      withCounter: boolean,
    }): any {
      return h(App, {
        productId: this.productId,
        productType: this.productType ?? undefined,
        cartRoute: this.cartRoute,
        checkoutRoute: this.checkoutRoute,
        basketButtonTitle: this.basketButtonTitle,
        orderButtonTitle: this.orderButtonTitle,
        withCounter: this.withCounter,
      })
    },
  },
  replaceMode: true,
})

export const { bootstrap } = vueLifecycles
export const { mount } = vueLifecycles
export const { unmount } = vueLifecycles
